import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { TertiaryButton } from 'scy/buttons';
import { Hero, H2, H3, H5, Paragraph, Body } from 'scy/text';
import { darkBgPrimary, highlight } from 'scy/text/styles.mod.scss';
import AccountLinkForm from './accountLinkForm';
import styles from './styles.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { flex, column } from 'scy/flex.mod.scss';
import { textCenter, width50 } from 'scy/utils.mod.scss';
import { absolute } from 'scy/position.mod.scss';
import config from 'sharedConfig';
import EmjayLogo from 'images/emjay/emjay-logo-wordmark.svg?react-svg';
import { trackNow } from 'shared/models/analytic';
import { BUTTON_CLASSES } from 'scy/buttons';

const URL = config.emjay.url;
const tracking_param =
  '&utm_source=saucey&utm_medium=ios&utm_campaign=account_link_success';

export default function AccountLinkModal() {
  const user = useSelector(state => state.login.user || {});
  const [accepted, setAccepted] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const userAccountType =
    user.authData && user.authData.facebook
      ? 'facebook'
      : user.authData && user.authData.apple
      ? 'apple'
      : user.email
      ? 'email/pw'
      : 'anonymous';

  function toggleErrorModal() {
    setShowErrorModal(!showErrorModal);
  }

  return (
    <>
      <div className={styles.welcomeScreen}>
        <Header />
        <div className={styles.welcomeContentArea}>
          <div className={classnames(padding.md, textCenter)}>
            <section>
              <H5 className={highlight} uppercase>
                WHAT IS EMJAY?
              </H5>
              <Paragraph
                className={classnames(
                  styles.contentBodyFontSize,
                  margin.bottom_md
                )}
              >
                Emjay is like Saucey, but for weed delivery.
              </Paragraph>
            </section>
            <section>
              <H5 className={highlight} uppercase>
                THE BEST SELECTION & PRICING IN LA
              </H5>
              <Paragraph
                className={classnames(
                  styles.contentBodyFontSize,
                  margin.bottom_md
                )}
              >
                3x the selection of other services, at prices cheaper than going
                to the dispensary.
              </Paragraph>
            </section>
            <section>
              <H5 className={highlight} uppercase>
                ONE LOGIN FOR BOTH
              </H5>
              <Paragraph className={styles.contentBodyFontSize}>
                Use your Saucey email/password to sign in to Emjay.
              </Paragraph>
            </section>
          </div>
          <CTAFooter>
            <H2 className={classnames(textCenter, styles.ctaTitle)}>
              Sign in with your Saucey <br /> account to get
              <span className={highlight}> $10 OFF</span>
              <br />
              your first Emjay delivery.
            </H2>
            <TertiaryButton
              onClick={() => {
                setAccepted(true);
                trackNow('Conversion Sign In Button Clicked', {
                  account_type: userAccountType
                });
              }}
              className={classnames(width50, margin.sides_auto, margin.top_sm)}
            >
              sign in
            </TertiaryButton>
          </CTAFooter>
        </div>
      </div>
      {accepted && (
        <div className={classnames(styles.accountLinkForm, padding.md)}>
          <AccountLinkForm
            initUser={user}
            onSuccess={data =>
              (window.location = data.redirect_url + tracking_param)
            }
            userAccountType={userAccountType}
            toggleErrorModal={toggleErrorModal}
            setErrorMessage={setErrorMessage}
          />
        </div>
      )}
      {showErrorModal ? (
        <ErrorModal
          className={classnames(styles.errorModal, absolute)}
          errorMessage={errorMessage}
        >
          <Hero
            className={classnames(textCenter, margin.top_xl, darkBgPrimary)}
          >
            Deja Vu!
          </Hero>
        </ErrorModal>
      ) : null}
    </>
  );
}

const Header = () => {
  return (
    <div className={classnames(padding.md, styles.header, textCenter)}>
      <H2
        className={classnames(darkBgPrimary, margin.top_sm)}
        style={{ lineHeight: '1' }}
      >
        We launched cannabis delivery
      </H2>
      <H3 className={darkBgPrimary}>
        Introducing
        <span>
          <EmjayLogo
            color="#ffffff"
            height={40}
            width={100}
            style={{ transform: 'translateY(20px)' }}
          />
        </span>
      </H3>
    </div>
  );
};

const CTAFooter = ({ children }) => (
  <div
    className={classnames(
      styles.ctaFooter,
      padding.top_sm,
      padding.bottom_sm,
      padding.left_md,
      padding.right_md,
      flex,
      column
    )}
  >
    {children}
  </div>
);

const ErrorModal = ({ children, errorMessage, ...rest }) => {
  return (
    <div className={styles.errorModal} {...rest}>
      <div className={classnames(styles.errorModalContentArea, absolute)}>
        <div
          className={classnames(
            padding.top_lg,
            padding.right_md,
            padding.left_md,
            textCenter
          )}
        >
          <Body
            className={classnames(
              styles.contentTitleFontSize,
              highlight,
              margin.bottom_sm
            )}
          >
            You&apos;ve been here before
          </Body>
          <Body
            className={classnames(styles.contentBodyFontSize, margin.bottom_sm)}
          >
            {errorMessage}
          </Body>
          <Body
            className={classnames(styles.contentBodyFontSize, margin.bottom_md)}
          >
            No problem, let&apos;s head over to Emjay
            <br />
            and sign in.
          </Body>
          <a href={URL} className={BUTTON_CLASSES.tertiary}>
            go to emjay
          </a>
        </div>
      </div>
      {children}
    </div>
  );
};
